export const hoursRelationship = {
    collapsible: false,
    title: 'Hours',
    tint: 'default',
    type: 'hours',
};
